import React from 'react';
import { Icon } from 'react-materialize';
import {
  DEVELOPER_ATTRIBUTION_TEXT,
  DEVELOPER_COMPANY_NAME,
  DEVELOPER_WEBSITE_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  SITE_NAME,
} from '../../config/constants';
import eternalKnot from '../../img/Endlessknot.svg';
import './styles.scss';

export const FooterComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='custom-footer'>
      <div className='footer-main'>
        <div className='footer-content'>
          <a
            href={INSTAGRAM_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='social-icon'
            aria-label='Instagram'
          >
            <Icon>camera_alt</Icon>
          </a>
          <img src={eternalKnot} alt="Eternal knot" className="eternal-knot-icon" />
          <a
            href={LINKEDIN_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='social-icon'
            aria-label='LinkedIn'
          >
            <Icon>work</Icon>
          </a>
        </div>
      </div>
      <div className='footer-disclaimer'>
        <p>
         <strong>Disclaimer:</strong> Mindfulness instruction and consulting offered through this site are educational in nature and are not a substitute for medical, psychological, or therapeutic care. I do not diagnose, treat, or provide clinical services. Participants are responsible for their own wellbeing and should seek appropriate professional support when needed.
        </p>
      </div>
      <div className="footer-copyright">
        Copyright © {currentYear} {SITE_NAME}, All rights reserved. {DEVELOPER_ATTRIBUTION_TEXT}{' '}
        <a href={DEVELOPER_WEBSITE_URL} target="_blank" rel="noopener noreferrer">
          {DEVELOPER_COMPANY_NAME}
        </a>
        .
      </div>
    </footer>
  );
};
